import { MarkerCollectionItemT } from 'bovaljaren-models';
import { CSSProperties } from 'react';
import { measureImage } from '../mapping/mapping.helper';

export type MarkerPositionT = {x: number; y: number}

const getMarkerAlignment = (markerPosition: {x: number; y: number}): string => {
    // Figure out if polygon is mostly on the left or right hand side of the image.
    if (markerPosition.x > 50) {
        return 'right';
    }

    return 'left';
};


const calculateMarkerStyle = (markerPosition?: MarkerPositionT, imageDimensions?: {width: number; height: number}, hasImage?: boolean, marker?: MarkerCollectionItemT, scale?: number, initialMargin?: number): CSSProperties => {
    if (!marker) {
        return {};
    }

    if (!markerPosition) {
        return {};
    }

    if (!imageDimensions?.width) {
        measureImage();
    }

    const style: CSSProperties = {
        top: `calc(${(Math.round(markerPosition.y * 100) / 100)}% - ${hasImage ? 152 : 70}px)`
    };

    const margin = (initialMargin || 0) + 50 - (25 * (scale || 1) * (scale || 1));

    if (getMarkerAlignment(markerPosition) === 'left') {
        style['left'] = `calc(${(Math.round(markerPosition.x * 100) / 100)}% + ${margin}px)`;
    }
    else {
        style['right'] = `calc(${(Math.round((100 - markerPosition.x) * 100) / 100)}% + ${margin}px)`;
    }

    return style;
};

const calculateMarkerTipStyle = (markerPosition?: MarkerPositionT, marker?: MarkerCollectionItemT): CSSProperties => {
    if (!marker) {
        return {};
    }

    if (!markerPosition) {
        return {};
    }

    const style: CSSProperties = {
        top: 'calc(50% - 8px)',
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent'
    };

    if (getMarkerAlignment(markerPosition) === 'left') {
        style['left'] = '-16px';
        style['borderRightWidth'] = '16px';
    }
    else {
        style['right'] = '-16px';
        style['borderLeftWidth'] = '16px';
    }

    return style;
};

const calculateMarkerTipForegroundStyle = (markerPosition?: MarkerPositionT, marker?: MarkerCollectionItemT): CSSProperties => {
    if (!marker) {
        return {};
    }

    if (!markerPosition) {
        return {};
    }

    const style: CSSProperties = {
        top: 'calc(50% - 3px)',
        borderTop: '7px solid transparent',
        borderBottom: '7px solid transparent'
    };

    if (getMarkerAlignment(markerPosition) === 'left') {
        style['left'] = '-11px';
        style['borderRightWidth'] = '11px';
    }
    else {
        style['right'] = '-11px';
        style['borderLeftWidth'] = '11px';
    }

    return style;
};


export { calculateMarkerStyle, calculateMarkerTipForegroundStyle, calculateMarkerTipStyle, getMarkerAlignment, measureImage };